import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Business, LocationCity } from "@mui/icons-material";
import { styled, useTheme } from "@mui/material/styles";
import { useIsAuthenticated, useMsal, useAccount } from "@azure/msal-react";
import Logout from "@mui/icons-material/Logout";
import { Box, useMediaQuery } from "@mui/material";

const drawerWidth = 210;

const StyledList = styled(List)({
  // selected and (selected + hover) states
  "&& .Mui-selected, && .Mui-selected:hover": {
    backgroundColor: "#edfaff",
    "&, & .MuiListItemIcon-root": {
      color: "#006b99",
    },
  },
  // hover states
  "& .MuiListItem-root:hover": {
    backgroundColor: "#edfaff",
    "&, & .MuiListItemIcon-root": {
      color: "#006b99",
    },
  },
});

function Navbar() {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const accounts = instance.getAllAccounts();
  const account = useAccount(accounts[0]);
  //useState
  //const signInLabel = isAuthenticated ?  'Signed in as ' + account?.username  : '';

  let navigate = useNavigate();
  const routeChange = (param: any) => {
    return param === "Branch"
      ? navigate("/branch-table")
      : param === "District"
      ? navigate("/branch-district")
      : param === "Division"
      ? navigate("/branch-division")
      : param === "Region"
      ? navigate("/branch-region")
      : "";
  };
  const logout = () => {
    const logoutRequest = {
      account: account,
    };
    instance.logoutRedirect(logoutRequest);
  };
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [open, setOpen] = useState(false);
  const toggleDrawer = (event: any) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(!open);
  };
  const drawer = (
    <>
      <br />
      <Link to="/">
        {" "}
        <img src="/summitlogo.png" alt="SUMMIT-LOGO" />{" "}
      </Link>
      <StyledList>
        {["Branch", "District", "Division", "Region"].map((text, index) => (
          <ListItem onClick={() => routeChange(text)} key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index === 0 ? (
                  <MapsHomeWorkOutlinedIcon />
                ) : index === 1 ? (
                  <LocationCity />
                ) : index === 2 ? (
                  <Business />
                ) : (
                  <MapOutlinedIcon />
                )}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem
          sx={{
            display: !isAuthenticated ? "none" : "inline",
          }}
          onClick={() => logout()}
          disablePadding
        >
          <ListItemButton>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>
      </StyledList>
    </>
  );

  return (
    <div style={{ display: "flex" }}>
      <CssBaseline />

      <AppBar
        elevation={0}
        position="fixed"
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          backgroundColor: "#009adc",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer}
            sx={{
              mr: theme.spacing(2),
              [theme.breakpoints.up("md")]: {
                display: "none",
              },
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Branch Hierarchy
          </Typography>
          <Typography
            component="div"
            sx={{
              display: "flex",
              float: "right",
            }}
          >
            {isAuthenticated ? "Signed in as " + account?.name : ""}
          </Typography>
        </Toolbar>
      </AppBar>
      <Divider />
      <Drawer
        sx={{
          flexShrink: 0,
          width: drawerWidth,
          "& .MuiDrawer-paper": {
            [theme.breakpoints.down("sm")]: {
              top: `${theme.mixins.toolbar.minHeight}px`,
            },
          },
        }}
        variant={isMdUp ? "permanent" : "temporary"}
        anchor="left"
        open={open}
        onClose={toggleDrawer}
      >
        <Box
          sx={{
            ...theme.mixins.toolbar,
            [`${theme.breakpoints.down("sm")}`]: {
              display: "none",
            },
          }}
        />

        {drawer}
        <Divider />
      </Drawer>
    </div>
  );
}

export default Navbar;
